import { render, staticRenderFns } from "./WorkloadStatistics.vue?vue&type=template&id=c4bfc3f0&scoped=true&"
import script from "./workloadStatistics.js?vue&type=script&lang=js&"
export * from "./workloadStatistics.js?vue&type=script&lang=js&"
import style0 from "./WorkloadStatistics.vue?vue&type=style&index=0&id=c4bfc3f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bfc3f0",
  null
  
)

export default component.exports